// Import category icons - Legacy icons
import CcIcon from '../app/assets/icons/apps_icons/Creative Cloud Team.svg';
import DocCloud from '../app/assets/icons/apps_icons/Doc Cloud.svg';
import Express from '../app/assets/icons/apps_icons/Express.svg';
import FrameIcon from '../app/assets/icons/apps_icons/Frame.svg';
import Imaging from '../app/assets/icons/apps_icons/Imaging.svg';
import Firefly from '../app/assets/icons/apps_icons/Firefly.svg';
import ProVideo from '../app/assets/icons/apps_icons/Pro Video.svg';
import AdobeFonts from '../app/assets/icons/apps_icons/B_app_AdobeFonts.svg';
import AdobeIcon from '../app/assets/icons/apps_icons/AdobeIcon.svg';

// Import new Figma icons - Print & Publishing
import Illustrator from '../app/assets/icons/apps_icons/B_app_Illustrator.svg';
import InCopy from '../app/assets/icons/apps_icons/B_app_InCopy.svg';
import InDesign from '../app/assets/icons/apps_icons/B_app_InDesign.svg';
import InDesignServer from '../app/assets/icons/apps_icons/B_app_InDesignServer.svg';

// Import new Figma icons - Digital Imaging
import Fresco from '../app/assets/icons/apps_icons/B_app_Fresco.svg';
import Photoshop from '../app/assets/icons/apps_icons/B_app_Photoshop.svg';
import Lightroom from '../app/assets/icons/apps_icons/B_app_Lightroom.svg';
import LightroomClassic from '../app/assets/icons/apps_icons/B_app_LightroomClassic.svg';
import CameraRaw from '../app/assets/icons/apps_icons/B_app_CameraRaw.svg';

// Import new Figma icons - 3D & AR
import Substance3DCollection from '../app/assets/icons/apps_icons/B_app_Substance3DCollection.svg';
import Substance3DAssets from '../app/assets/icons/apps_icons/B_app_Substance3DAssets.svg';
import CommunityAssets from '../app/assets/icons/apps_icons/B_app_communityAssets.svg';
import SubstanceReviewer from '../app/assets/icons/apps_icons/B_app_SubstanceReviewer.svg';
import Substance3DPainter from '../app/assets/icons/apps_icons/B_app_Substance3DPainter.svg';
import Substance3DDesigner from '../app/assets/icons/apps_icons/B_app_Substance3DDesigner.svg';
import Substance3DStager from '../app/assets/icons/apps_icons/B_app_Substance3DStager.svg';
import Substance3DSampler from '../app/assets/icons/apps_icons/B_app_Substance3DSampler.svg';
import Dimension from '../app/assets/icons/apps_icons/B_app_Dimension.svg';
import Modeler from '../app/assets/icons/apps_icons/B_app_Modeler.svg';
import Mixamo from '../app/assets/icons/apps_icons/B_app_Mixamo.svg';

// Import new Figma icons - Adobe Express
import AdobeExpress from '../app/assets/icons/apps_icons/B_app_AdobeExpress.svg';
import SparkPage from '../app/assets/icons/apps_icons/B_app_SparkPage.svg';
import SparkVideo from '../app/assets/icons/apps_icons/B_app_SparkVideo.svg';

// Import new Figma icons - Video/DVA
import AfterEffects from '../app/assets/icons/apps_icons/B_app_AfterEffects.svg';
import PremierePro from '../app/assets/icons/apps_icons/B_app_PremierePro.svg';
import Audition from '../app/assets/icons/apps_icons/B_app_Audition.svg';
import MediaEncoder from '../app/assets/icons/apps_icons/B_app_MediaEncoder.svg';
import PremiereRush from '../app/assets/icons/apps_icons/B_app_PremiereRush.svg';
import CharacterAnimator from '../app/assets/icons/apps_icons/B_app_CharacterAnimator.svg';
import Animate from '../app/assets/icons/apps_icons/B_app_Animate.svg';

// Import new Figma icons - Web & UX
import Dreamweaver from '../app/assets/icons/apps_icons/B_app_Dreamweaver.svg';
import XD from '../app/assets/icons/apps_icons/B_app_XD.svg';
import Aero from '../app/assets/icons/apps_icons/B_app_Aero.svg';

// Import new Figma icons - Gen AI
import AdobeFirefly from '../app/assets/icons/apps_icons/B_app_AdobeFirefly.svg';
import GenerativeCredits from '../app/assets/icons/apps_icons/B_app_GenerativeCredits.svg';

// Import new Figma icons - Experience Cloud
import ExperienceCloud from '../app/assets/icons/apps_icons/B_app_ExperienceCloud.svg';
import AdvertisingCloud from '../app/assets/icons/apps_icons/B_app_AdvertisingCloud.svg';
import AnalyticsCloud from '../app/assets/icons/apps_icons/B_app_AnalyticsCloud.svg';
import CommerceCloud from '../app/assets/icons/apps_icons/B_app_CommerceCloud.svg';
import MarketingCloud from '../app/assets/icons/apps_icons/B_app_MarketingCloud.svg';
import ExperiencePlatform from '../app/assets/icons/apps_icons/B_app_ExperiencePlatform.svg';
import Workfront from '../app/assets/icons/apps_icons/B_app_Workfront.svg';

// Import new Figma icons - Document Cloud
import AdobeDocumentCloud from '../app/assets/icons/apps_icons/B_app_AdobeDocumentCloud.svg';
import AdobeAcrobatClassic from '../app/assets/icons/apps_icons/B_app_AdobeAcrobatClassic.svg';
import AdobeAcrobatPDF from '../app/assets/icons/apps_icons/B_app_AdobeAcrobatPDF.svg';
import AdobeAcrobatPro from '../app/assets/icons/apps_icons/B_app_AdobeAcrobatPro.svg';
import AdobeSign from '../app/assets/icons/apps_icons/B_app_AdobeSign.svg';
import AdobeScan from '../app/assets/icons/apps_icons/B_app_AdobeScan.svg';
import AdobeDistiller from '../app/assets/icons/apps_icons/B_app_AdobeDistiller.svg';
import FillAndSign from '../app/assets/icons/apps_icons/B_app_FillAndSign.svg';
import AcrobatDiagnostics from '../app/assets/icons/apps_icons/B_app_AcrobatDiagnostics.svg';

// Import new Figma icons - Cross Cloud
import Behance from '../app/assets/icons/apps_icons/B_app_Behance.svg';
import Bridge from '../app/assets/icons/apps_icons/B_app_Bridge.svg';
import Capture from '../app/assets/icons/apps_icons/B_app_Capture.svg';
import Stock from '../app/assets/icons/apps_icons/B_app_Stock.svg';
import Portfolio from '../app/assets/icons/apps_icons/B_app_Portfolio.svg';

// Import new Figma icons - Other
import CreativeCloud from '../app/assets/icons/apps_icons/B_app_CreativeCloud.svg';
import AdobeColor from '../app/assets/icons/apps_icons/B_app_AdobeColor.svg';
import UXPDeveloperTools from '../app/assets/icons/apps_icons/B_app_UXPDeveloperTools.svg';

// Create a mapping of categories/products to icons
export const categoryIcons: { [key: string]: any } = {
  // Legacy mappings
  'Creative Cloud Team': CcIcon,
  'Creative Cloud': CreativeCloud,
  'Doc Cloud': DocCloud,
  Express: AdobeExpress, // Use Adobe Express icon for legacy Express
  Frame: FrameIcon,
  Imaging: Imaging,
  'Adobe Fonts': AdobeFonts,
  'Pro Video': ProVideo,
  AdobeIcon: AdobeIcon,

  // Print & Publishing products
  'Illustrator Desktop (Ai)': Illustrator,
  'Illustrator Web (Ai)': Illustrator,
  Illustrator: Illustrator,
  'InDesign Desktop (Id)': InDesign,
  'InDesign Web (Id)': InDesign,
  InDesign: InDesign,
  'Pro Design': InDesign,
  InCopy: InCopy,
  'InDesign Server': InDesignServer,

  // Video products
  'After Effects (Ae)': AfterEffects,
  'After Effects': AfterEffects,
  'Premiere Pro Desktop (Pr)': PremierePro,
  'Premiere Mobile (Pr)': PremierePro, // Use Premiere Pro icon for mobile
  'Premiere Web (Pr)': PremierePro,
  'Premiere Pro': PremierePro,
  Premiere: PremierePro,
  'Premiere Rush': PremiereRush,
  'Pro Video Services/APIs': ProVideo,
  Audition: Audition,
  'Media Encoder': MediaEncoder,
  'Character Animator': CharacterAnimator,
  Animate: Animate,

  // Premiere shorthand mappings
  'Premiere Mobile iOS (Pr)': PremierePro,
  'Premiere Mobile Android (Pr)': PremierePro,
  'Premiere Desktop (Pr)': PremierePro,

  // Web & UX products
  Dreamweaver: Dreamweaver,
  XD: XD,
  'Adobe XD': XD,
  Aero: Aero,

  // Experimental/Project products
  'Project Neo': AdobeExpress, // Project Neo/Oasis - use Express icon
  'Project Oasis': AdobeExpress,
  'Project Neo/Oasis': AdobeExpress, // Combined project name
  Neo: AdobeExpress, // Shorthand for Project Neo
  Oasis: AdobeExpress, // Shorthand for Project Oasis

  // Firefly products
  'Firefly.com Web (FF)': AdobeFirefly,
  'Firefly Mobile (FF)': AdobeFirefly,
  'Firefly Services (FFS)': AdobeFirefly,
  'Firefly Customization (FFCM)': AdobeFirefly,
  'Firefly Experience (FFCP)': AdobeFirefly,
  'Firefly Brand Management': AdobeFirefly,
  Firefly: AdobeFirefly,

  // Firefly shorthand mappings
  FFBrand: AdobeFirefly, // Shorthand for Firefly Brand Management

  // Digital Imaging products
  'Photoshop Desktop (Ps)': Photoshop,
  'Photoshop Mobile (Ps)': Photoshop,
  'Photoshop Web (Ps)': Photoshop,
  Photoshop: Photoshop,
  'Lightroom (Lr)': Lightroom,
  'Lightroom Web (Lr)': Lightroom,
  'Lightroom Mobile (Lr)': Lightroom,
  Lightroom: Lightroom,
  'Lightroom Classic (Lr)': LightroomClassic,
  'Lightroom Classic': LightroomClassic,
  Fresco: Fresco,
  'Camera Raw': CameraRaw,

  // 3D & AR products
  '3D Enterprise': Substance3DCollection,
  '3D for 2D': Substance3DCollection,
  '3D Pros': Substance3DCollection,
  Substance: Substance3DCollection,
  'Substance 3D Collection': Substance3DCollection,
  'Substance 3D Assets': Substance3DAssets,
  'Community Assets': CommunityAssets,
  'Substance Reviewer': SubstanceReviewer,
  'Substance 3D Painter': Substance3DPainter,
  'Substance 3D Designer': Substance3DDesigner,
  'Substance 3D Stager': Substance3DStager,
  'Substance 3D Sampler': Substance3DSampler,
  Dimension: Dimension,
  Modeler: Modeler,
  Mixamo: Mixamo,

  // Simplified 3D product name mappings
  Designer: Substance3DDesigner,
  Painter: Substance3DPainter,
  Sampler: Substance3DSampler,
  Stager: Substance3DStager,
  SAWS: Substance3DCollection, // SAWS (Substance Asset Web Service) - use Collection icon
  '3D in Frame': Substance3DCollection, // 3DI products use Collection icon
  '3D Cloud Services': Substance3DCollection,
  '3D Asset Platform': Substance3DCollection,
  '3D Asset Production': Substance3DCollection,

  // Adobe Express products
  'Express Foundation': AdobeExpress,
  'Express Acrobat': AdobeExpress,
  'Express Enterprise': AdobeExpress,
  'Express CC Integration': AdobeExpress,
  'Express Ai Differentiation': AdobeExpress,
  'Adobe Express': AdobeExpress,
  'Spark Page': SparkPage,
  'Spark Video': SparkVideo,

  // Experience Cloud products
  'Experience Cloud': ExperienceCloud,
  'Advertising Cloud': AdvertisingCloud,
  'Analytics Cloud': AnalyticsCloud,
  'Commerce Cloud': CommerceCloud,
  'Marketing Cloud': MarketingCloud,
  'Experience Platform': ExperiencePlatform,
  Workfront: Workfront,

  // Document Cloud products
  'Document Cloud': AdobeDocumentCloud,
  'Document Cloud APIs': AdobeDocumentCloud,
  'Acrobat Classic': AdobeAcrobatClassic,
  'Acrobat PDF': AdobeAcrobatPDF,
  'Acrobat Pro': AdobeAcrobatPro,
  'Acrobat Studio': AdobeAcrobatPro,
  Sign: AdobeSign,
  'Adobe Sign': AdobeSign,
  Scan: AdobeScan,
  'Adobe Scan': AdobeScan,
  Distiller: AdobeDistiller,
  'Fill and Sign': FillAndSign,
  'Acrobat Diagnostics': AcrobatDiagnostics,

  // Gen AI products
  'GenStudio Modules': GenerativeCredits,
  'Generative Credits': GenerativeCredits,

  // Cross Cloud products
  Stock: Stock,
  'Stock 2.0': Stock,
  Content: Stock,
  Behance: Behance,
  Bridge: Bridge,
  Capture: Capture,
  Portfolio: Portfolio,

  // Frame.io
  'Frame.io': FrameIcon,

  // Services/APIs
  'Pro Design Services/APIs': InDesign,

  // Other products
  'Adobe Color': AdobeColor,
  'UXP Developer Tools': UXPDeveloperTools,

  // Student products
  'Student (K12)': CreativeCloud,
  'Student Teacher Edition (STE)': CreativeCloud,
  'Higher Education (HED)': CreativeCloud,

  // Adobe.com
  'Adobe.com': AdobeIcon
};

/**
 * Gets the appropriate category icon based on categories and products arrays
 * @param categories - Array of category strings (kept for backwards compatibility but not used)
 * @param products - Array of product strings (optional)
 * @returns Icon path string for first product (legacy support)
 * @deprecated Use getProductIcons instead for multiple icons
 */
export const getCategoryIcon = (
  categories: string[] | undefined,
  products?: string[] | undefined
): string => {
  // Only use products array, ignore categories
  if (products && Array.isArray(products)) {
    for (const product of products) {
      const icon = categoryIcons[product];
      if (icon) {
        return icon;
      }
    }
  }

  // If products is a string, try that
  if (products && typeof products === 'string') {
    const icon = categoryIcons[products];
    if (icon) {
      return icon;
    }
  }

  // Final fallback to AdobeIcon
  return AdobeIcon;
};

/**
 * Gets up to 3 product icons from the products array
 * IMPORTANT: Maintains the exact order of products as provided in the input array.
 * The order will be consistent across all views (Timeline, Cards, SlideOut Header).
 *
 * @param products - Array or string of product names
 * @returns Array of icon paths (up to 3) in the same order as input
 *          For each product without a mapping, returns fallback Adobe icon
 *
 * @example
 * getProductIcons(['Photoshop', 'Illustrator', 'InDesign'])
 * // Returns icons in order: [PhotoshopIcon, IllustratorIcon, InDesignIcon]
 *
 * getProductIcons(['Photoshop', 'UnknownProduct', 'Illustrator'])
 * // Returns: [PhotoshopIcon, AdobeIcon (fallback), IllustratorIcon]
 *
 * getProductIcons(['UnknownProduct'])
 * // Returns: [AdobeIcon (fallback)]
 */
export const getProductIcons = (
  products?: string[] | string | undefined
): string[] => {
  if (!products) return [];

  // Convert to array if it's a single product string
  const productsArray = Array.isArray(products) ? products : [products];

  // Get icons for up to 3 products - PRESERVING ORIGINAL ORDER
  // If a product doesn't have a mapping, use fallback Adobe icon
  const icons: string[] = [];
  for (let i = 0; i < Math.min(productsArray.length, 3); i++) {
    const product = productsArray[i];
    const icon = categoryIcons[product];

    // Use matched icon if available, otherwise use fallback Adobe icon
    icons.push(icon || categoryIcons.AdobeIcon);
  }

  return icons;
};
